import { connect } from 'react-redux'
import { checkWaiChu } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    checkWaiChu
}
const mapStateToProps = (state) => {
  return {
    ...state.WaiChuCheck
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
